export default {
  xeroReportExpenseLineItem: undefined,
  xeroReportExpenseLineItems: [],
};
